export { Button as default } from './Button'
